export const ALLOWED_UPLOAD_EXTENSIONS = [
  ".zip", ".mp4", ".jpg", ".jpeg", ".png", 
  ".fbx", ".obj", ".glb", ".gltf", ".usdz", 
  ".mtl", ".bin"
];
